export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taker"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maker"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taker ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maker ID"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platíte"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dostáváte"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Čekací doba"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jméno"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bankovní účet/Peněženka"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Popis"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádný název banky"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádný bankovní účet"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jméno nebylo poskytnuto"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Účet nebyl poskytnut"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Externí"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Interní"])}
}